import React, { useState, useEffect } from 'react';
import heroImage from '../assets/heroImage.png';
import briefcase from '../assets/Briefcase.png';
import chartbar from '../assets/ChartBar.png';
import gift from '../assets/Gift.png';
import airplane from '../assets/AirplaneTilt.png';
import chat from '../assets/ChatsCircle.png';
import user from '../assets/UserCircleGear.png';
import consultationCard from '../assets/consultationcard.png';
import ConsultationDetail from './ConsultationDetail';

const testimonials = [
  {
    image: 'https://avatar.iran.liara.run/public/boy',
    alt: 'Ritika Sharma',
    stars: 5,
    text: "I initially booked the consultation because I wanted a good dining credit card but had no idea where to start. Aman took the time to understand my spending habits and suggested the IndusInd EazyDiner Card along with the HDFC Swiggy Card. What I liked most was that he didn't just recommend cards, he explained the complete application process, eligibility requirements, and what to expect after applying. The session saved me a lot of trial and error.",
  },
  {
    image: 'https://avatar.iran.liara.run/public/girl',
    alt: 'Nikhil Verma',
    stars: 4.5,
    text: "The best part of my consultation with Vishwas was that I never felt judged. I had a lot of basic questions and some mistakes in the way I was using my cards, but he listened patiently and explained everything clearly. He even pointed out benefits and features on my existing credit cards that I wasn't aware of. I walked away with much more knowledge than I expected!",
  },
  {
    image: 'https://avatar.iran.liara.run/public/job/doctor/male',
    alt: 'Rahul Gupta',
    stars: 3,
    text: 'The consultation was decent and most of my questions were answered. However, it felt a bit rushed at times, almost like the discussion was moving through a checklist. While I did receive the information I needed, I was expecting a deeper conversation and more detailed guidance based on my situation. Not a bad experience, but not as personalized as I had hoped.',
  },
  {
    image: 'https://avatar.iran.liara.run/public/girl?username=Maria',
    alt: 'Pooja Malhotra',
    stars: 4,
    text: "I was struggling to understand credit card billing cycles, statement generation dates, and payment due dates. Vishwas explained everything from the absolute basics and answered every question patiently without making me feel embarrassed. Thanks to the guidance I received over multiple consultations, I now have a portfolio of three lifetime-free credit cards that perfectly suit my needs, and I'm finally able to maximize their benefits confidently.",
  },
  {
    image: 'https://avatar.iran.liara.run/public/boy?username=Scott',
    alt: 'Amit Bansal',
    stars: 5,
    text: "As a business owner, I had the HDFC Biz Black card but wasn't really using it effectively. During my consultation, Aman showed me how to use the SmartBuy portal strategically for business expenses and maximize reward earnings. He even shared a screen recording afterwards so I could revisit the process and understand it properly. That extra effort made a huge difference.",
  },
  {
    image: 'https://avatar.iran.liara.run/public/boy?username=Scott',
    alt: 'Sneha Kapoor',
    stars: 3.5,
    text: 'I thought I needed another premium credit card, but after reviewing my existing cards, Vishwas actually advised me against applying for one immediately. The recommendations felt honest and practical rather than sales-driven. The consultation helped me avoid unnecessary fees and make better use of the cards I already had.',
  },
  {
    image: 'https://avatar.iran.liara.run/public/boy?username=Scott',
    alt: 'Arvind Khanna',
    stars: 4.5,
    text: "I had initially tried reaching out through Card Academy emails and even sent a message to Manvi's official email, but I later realized that consultations need to be booked through the website. Since I wasn't aware of the process, it took me some time to actually get connected with the consultation team. That said, once I booked the session, the experience was excellent. The team guided me step-by-step on how to redeem my reward points for Accor travel benefits. It was my first time dealing with point transfers and hotel loyalty programs, but everything was explained in a very simple and practical way. By the end of the consultation, I was confident enough to complete the redemption process myself. Highly recommend booking a Card Academy consultation if you're confused about points, miles, or travel rewards.",
  },
];

function ReviewSection() {
  const [cur, setCur] = useState(0);

  useEffect(() => {
    const id = 'rv-style';
    if (document.getElementById(id)) return;
    const s = document.createElement('style');
    s.id = id;
    s.textContent = `
      .rv-track { display:flex; gap:14px; transition:transform 0.4s cubic-bezier(.4,0,.2,1); will-change:transform; }
      .rv-card { flex-shrink:0; width:260px; background:#fff; border-radius:14px; padding:18px;
        box-sizing:border-box; display:flex; flex-direction:column; gap:10px; min-height:220px; }
      .rv-text { font-size:12.5px; line-height:1.6; color:#374151; margin:0; flex:1;
        display:-webkit-box; -webkit-line-clamp:6; -webkit-box-orient:vertical; overflow:hidden; }
      .rv-user { display:flex; align-items:center; gap:10px; margin-top:auto;
        padding-top:10px; border-top:0.5px solid #e5e7eb; }
      .rv-avatar { width:36px; height:36px; border-radius:50%; object-fit:cover; }
      .rv-name { font-size:13px; font-weight:600; color:#111827; margin:0; }
      .rv-btn { position:absolute; top:50%; transform:translateY(-50%); width:38px; height:38px;
        border-radius:50%; background:#fff; border:none; cursor:pointer; display:flex;
        align-items:center; justify-content:center; box-shadow:0 2px 8px rgba(0,0,0,0.18); z-index:2; }
      .rv-btn:disabled { opacity:0.35; cursor:default; }
      .rv-btn:hover:not(:disabled) { background:#e8effe; }
      .rv-dot { width:7px; height:7px; border-radius:50%; background:rgba(255,255,255,0.4);
        border:none; cursor:pointer; padding:0; transition:background 0.2s, transform 0.2s; }
      .rv-dot.active { background:#fff; transform:scale(1.3); }
    `;
    document.head.appendChild(s);
  }, []);

  const CARD_W = 260;
  const GAP = 14;
  const STEP = CARD_W + GAP;
  const [maxIdx, setMaxIdx] = useState(testimonials.length - 3);
  const viewportRef = React.useRef(null);

  useEffect(() => {
    function calcMax() {
      if (viewportRef.current) {
        const vw = viewportRef.current.offsetWidth;
        const visible = Math.floor((vw + GAP) / STEP);
        setMaxIdx(Math.max(0, testimonials.length - visible));
      }
    }
    calcMax();
    window.addEventListener('resize', calcMax);
    return () => window.removeEventListener('resize', calcMax);
  }, []);

  const go = (idx) => setCur(Math.max(0, Math.min(idx, maxIdx)));

  function StarRow({ stars }) {
    return (
      <div style={{ display: 'flex', gap: 3, marginBottom: 6 }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <svg key={i} width="15" height="15" viewBox="0 0 24 24">
            <path
              d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
              fill={
                i < Math.floor(stars)
                  ? '#F59E0B'
                  : i === Math.floor(stars) && stars % 1 >= 0.5
                    ? '#F59E0B'
                    : '#E5E7EB'
              }
            />
          </svg>
        ))}
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: 'rgb(0, 57, 166)', padding: '48px 0 56px' }}>
      <h3
        style={{
          color: '#fff',
          fontSize: 28,
          fontWeight: 400,
          textAlign: 'center',
          margin: '0 0 32px',
        }}
      >
        Our Satisfied Customers
      </h3>

      {/* Carousel */}
      <div
        style={{
          position: 'relative',
          padding: '0 52px',
          boxSizing: 'border-box',
          overflow: 'hidden',
        }}
      >
        {/* Prev button */}
        <button
          className="rv-btn"
          onClick={() => go(cur - 1)}
          disabled={cur === 0}
          style={{ left: 4 }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#0039A6"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        {/* Viewport */}
        <divs ref={viewportRef} tyle={{ overflow: 'hidden', width: '100%' }}>
          <div
            className="rv-track"
            style={{ transform: `translateX(-${cur * STEP}px)` }}
          >
            {testimonials.map((t, i) => (
              <div key={i} className="rv-card">
                <StarRow stars={t.stars} />
                <p className="rv-text">{t.text}</p>
                <div className="rv-user">
                  <div style={{ position: 'relative', flexShrink: 0 }}>
                    <div
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: '50%',
                        background: '#0039A6',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: 13,
                        fontWeight: 600,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                      }}
                    >
                      {t.alt.charAt(0)}
                    </div>
                    <img
                      className="rv-avatar"
                      src={t.image}
                      alt={t.alt}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                  <span className="rv-name">{t.alt}</span>
                </div>
              </div>
            ))}
          </div>
        </divs>

        {/* Next button */}
        <button
          className="rv-btn"
          onClick={() => go(cur + 1)}
          disabled={cur >= maxIdx}
          style={{ right: 4 }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#0039A6"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>

      {/* Dots */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 6,
          marginTop: 24,
        }}
      >
        {testimonials.map((_, i) => (
          <button
            key={i}
            className={`rv-dot${i === cur ? ' active' : ''}`}
            onClick={() => go(i)}
            aria-label={`Go to review ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
export default function ConsultationPage() {
  const [faqIndex, setFaqIndex] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({ name: '', mobile: '', email: '' });
  const [errors, setErrors] = useState({ name: '', mobile: '', email: '' });

  const [vw, setVw] = useState(window.innerWidth);
  useEffect(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const isMobile = vw < 640;
  const isTablet = vw >= 640 && vw < 1024;

  const faqs = [
    {
      question: 'What’s included in the consultation fee?',
      answer:
        'You’ll receive a 60–90 minute 1-on-1 session with a credit card expert, a personalized card portfolio, a detailed spending strategy, reward optimization plan, travel redemptions guidance, and post-call support via email or chat.',
    },
    {
      question: 'Will you apply for the cards on my behalf?',
      answer:
        'No. We provide expert recommendations and clear application steps, but you’re always in control of where and when you apply.',
    },
    {
      question: 'Do I need to share sensitive financial information?',
      answer:
        'Not at all. We only ask about your lifestyle, spending categories, and travel goals. No account numbers or personal financial documents are required.',
    },
    {
      question: 'Who is this session best for?',
      answer:
        "Whether you’re new to credit cards, a reward points enthusiast, or a frequent traveler, this consultation is ideal if you're aiming to:\n- Optimize everyday spending returns\n- Maximize reward points on travel or shopping\n- Build a well-rounded card portfolio without excessive annual fees",
    },
    {
      question: 'What happens after the call?',
      answer:
        'After the session, you’ll have complete clarity on which credit cards suit your lifestyle, how to use them smartly, and how to make the most of your spending and rewards.',
    },
  ];

  const features = [
    {
      icon: briefcase,
      title: 'Get a personalized credit card portfolio',
      description: 'designed to generate 10–12% returns on your spends.',
    },
    {
      icon: chartbar,
      title: 'Receive a detailed spending strategy',
      description:
        'for each card—maximize both base and accelerated reward points without crossing ineffective limits.',
    },
    {
      icon: gift,
      title: 'Understand the right redemption strategy',
      description:
        'to ensure your reward points are used at full value—not wasted.',
    },
    {
      icon: airplane,
      title: 'Get tailored trip planning support',
      description:
        'including the best airline and hotel redemption partners for your goals.',
    },
    {
      icon: chat,
      title: 'Ask anything—during and after',
      description:
        'the session. All your credit card and travel-related questions will be answered, with follow-up support included.',
    },
    {
      icon: user,
      title: '60–90 minutes of expert-led consultation',
      description:
        'focused entirely on optimizing your lifestyle via smart credit card usage.',
    },
  ];

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!formData.name) errs.name = 'Name is required';
    if (!formData.mobile) errs.mobile = 'Mobile is required';
    if (!/^\d{10}$/.test(formData.mobile))
      errs.mobile = 'Please enter a valid 10-digit mobile number';
    if (!formData.email) errs.email = 'Email is required';
    if (!/\S+@\S+\.\S+/.test(formData.email))
      errs.email = 'Please enter a valid email address';
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    const payload = {
      name: formData.name,
      mobile: formData.mobile,
      email: formData.email,
    };
    try {
      const response = await fetch(
        'https://app.yaper.co/api/v2/retail/consult',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }
      );
      if (response.ok) {
        alert('Your consultation request has been sent successfully!');
        setFormData({ name: '', mobile: '', email: '' });
        setErrors({});
      } else {
        console.error('Error response:', await response.text());
        alert('Something went wrong. Please try again later.');
      }
    } catch (err) {
      console.error('Error sending request:', err);
      alert('An error occurred while sending the request.');
    }
  };

  // -------- Feature card + grid styles (3 per row desktop) --------
  const CARD_W = 260;
  const GAP = 30;
  const GRID_W_DESKTOP = CARD_W * 3 + GAP * 2;
  const GRID_W_TABLET = CARD_W * 2 + GAP * 1;

  const featureGridStyle = {
    display: 'grid',
    gridTemplateColumns: isMobile
      ? `repeat(1, ${CARD_W}px)`
      : isTablet
        ? `repeat(2, ${CARD_W}px)`
        : `repeat(3, ${CARD_W}px)`,
    gap: GAP,
    justifyContent: 'center',
    maxWidth: isMobile ? CARD_W : isTablet ? GRID_W_TABLET : GRID_W_DESKTOP,
    margin: '0 auto',
  };

  const BAND = 64;
  const featureCardBase = {
    width: CARD_W,
    borderRadius: 16,
    background: `linear-gradient(180deg, #EAF3FF 0px, #EAF3FF ${BAND}px, #FFFFFF ${BAND}px, #FFFFFF 100%)`,
    border: '1px solid #DDE6FF',
    boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
    padding: 18, // ↓ trimmed from 20px to reduce overall height ~4px
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
  };

  const featureIconStyle = {
    width: 64,
    height: 64,
    objectFit: 'contain',
    marginBottom: 12,
    alignSelf: 'flex-start',
  };
  const featureTitleStyle = {
    fontWeight: 800,
    fontSize: 18,
    color: '#0F172A',
    marginBottom: 10,
    lineHeight: 1.35,
  };
  const featureDescStyle = { fontSize: 14, color: '#4B5563', lineHeight: 1.6 };

  // CTA aligned to grid width
  const ctaBarWrap = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 40,
    width: '100%',
  };
  const ctaInner = {
    width: isMobile ? CARD_W : isTablet ? GRID_W_TABLET : GRID_W_DESKTOP,
    display: 'flex',
    justifyContent: 'center',
  };
  const ctaButton = {
    width: '100%',
    backgroundColor: '#FFFFFF',
    color: '#1F3C97',
    border: '1px solid #D9E3FF',
    borderRadius: 12,
    fontWeight: 800,
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
    padding: '16px 24px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    cursor: 'pointer',
  };

  return (
    <div style={{ fontFamily: 'sans-serif' }}>
      <ConsultationDetail
        visible={showPopup}
        onClose={() => setShowPopup(false)}
      />

      <section style={{ position: 'relative', height: '90vh', color: 'white' }}>
        <img
          src={heroImage}
          alt="Hero"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        <div
          style={{
            position: 'absolute',
            top: '25%',
            left: '10%',
            maxWidth: 450,
          }}
        >
          <h1
            style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: 10 }}
          >
            Get 10–12% Returns on Your Credit Card Spends
          </h1>
          <p style={{ marginBottom: 20 }}>
            Get access to free flights and 5-star hotel stays for the rest of
            your life.
          </p>
          <button
            onClick={() => setShowPopup(true)}
            style={{
              backgroundColor: '#0039A6',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: 5,
            }}
          >
            BOOK 1:1 CONSULTATION
          </button>
        </div>
      </section>

      <section
        style={{
          backgroundColor: '#0039A6',
          color: 'white',
          padding: '60px 20px',
        }}
      >
        <h2 style={{ textAlign: 'center', fontSize: 24, marginBottom: 30 }}>
          Why Book This 1:1 Credit Card Consultancy Session?
        </h2>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 40,
          }}
        >
          <div
            style={{
              width: '100%',
              maxWidth: 720,
              height: 380,
              backgroundColor: '#000',
              borderRadius: 20,
              overflow: 'hidden',
              boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/i3af8zGbZho"
              title="Consultation Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          </div>
        </div>

        {/* 3 per row on desktop (then 2, then 1) */}
        <div style={featureGridStyle}>
          {features.map((f, i) => (
            <div key={i} style={featureCardBase}>
              <img src={f.icon} alt={f.title} style={featureIconStyle} />
              <h4 style={featureTitleStyle}>{f.title}</h4>
              <p style={featureDescStyle}>{f.description}</p>
            </div>
          ))}
        </div>

        <div style={ctaBarWrap}>
          <div style={ctaInner}>
            <button style={ctaButton} onClick={() => setShowPopup(true)}>
              BOOK 1:1 CONSULTATION
            </button>
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: '#f2f8ff', padding: '60px 20px' }}>
        <div
          style={{
            maxWidth: 1000,
            margin: '0 auto',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div style={{ maxWidth: 460 }}>
            <h3>Ready to do luxury stays with your loved ones?</h3>
            <p>
              Slots fill up fast! Choose a time that works for you, and we’ll
              take care of the rest.
            </p>
          </div>
          <form
            onSubmit={handleFormSubmit}
            style={{
              backgroundColor: 'white',
              padding: 30,
              borderRadius: 10,
              width: 300,
              marginTop: 20,
            }}
          >
            <div style={{ marginBottom: 15 }}>
              <label>Name</label>
              <input
                type="text"
                placeholder="John Doe"
                name="name"
                value={formData.name}
                onChange={handleChange}
                style={{ width: '100%', padding: 8, marginTop: 5 }}
              />
              {errors.name && (
                <p style={{ color: 'red', fontSize: 12 }}>{errors.name}</p>
              )}
            </div>
            <div style={{ marginBottom: 20 }}>
              <label>Contact Number</label>
              <input
                type="text"
                placeholder="9511225450"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                style={{ width: '100%', padding: 8, marginTop: 5 }}
              />
              {errors.mobile && (
                <p style={{ color: 'red', fontSize: 12 }}>{errors.mobile}</p>
              )}
            </div>
            <div style={{ marginBottom: 20 }}>
              <label>Email</label>
              <input
                type="email"
                placeholder="example@mail.com"
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={{ width: '100%', padding: 8, marginTop: 5 }}
              />
              {errors.email && (
                <p style={{ color: 'red', fontSize: 12 }}>{errors.email}</p>
              )}
            </div>
            <button
              type="submit"
              style={{
                backgroundColor: '#0039A6',
                color: 'white',
                padding: 10,
                width: '100%',
                border: 'none',
                borderRadius: 5,
              }}
            >
              BOOK 1:1 CONSULTATION
            </button>
          </form>
        </div>
      </section>

      <ReviewSection />

      <section style={{ padding: '80px 20px', backgroundColor: '#fff' }}>
        <h2
          style={{
            textAlign: 'center',
            color: '#0039A6',
            marginBottom: 60,
            fontSize: 32,
            fontWeight: 700,
          }}
        >
          Frequently Asked Questions
        </h2>
        <div
          style={{
            maxWidth: 900,
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 28,
          }}
        >
          {faqs.map((faq, index) => {
            const isActive = faqIndex === index;
            return (
              <div
                key={index}
                onClick={() => setFaqIndex(isActive ? null : index)}
                style={{
                  minHeight: 130,
                  padding: 36,
                  backgroundColor: '#fff',
                  borderRadius: 16,
                  border: isActive ? '2px solid #1a237e' : '1px solid #e0e0e0',
                  boxShadow: isActive
                    ? '0 6px 20px rgba(0,0,0,0.12)'
                    : '0 2px 12px rgba(0,0,0,0.06)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: isActive ? 'flex-start' : 'center',
                }}
              >
                <div style={{ flex: 1 }}>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      fontWeight: 600,
                      color: '#1a1a1a',
                      marginBottom: isActive ? 14 : 0,
                    }}
                  >
                    {faq.question}
                  </p>
                  {isActive && (
                    <p
                      style={{
                        margin: 0,
                        color: '#555',
                        fontSize: 16,
                        lineHeight: 1.6,
                      }}
                    >
                      {faq.answer}
                    </p>
                  )}
                </div>

                <div
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    backgroundColor: '#27409C',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: 20,
                    flexShrink: 0,
                    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    style={{
                      transform: isActive ? 'rotate(180deg)' : 'none',
                      transition: 'transform 0.25s ease',
                      display: 'block',
                    }}
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      d="M6 9l6 6 6-6"
                      stroke="#ffffff"
                      strokeWidth="2.2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
